import { deviceType } from "@tm/isomorphic-utils";
import { FormattedText } from "@tm/static";
import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";
import { IPlansHeaderData } from "./types";

// ──── Styles ────

const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;

  @media ${deviceType.mobile} {
    flex-direction: column;
    gap: 16px;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const InsurerLogo = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 10px;
  border: 1.5px solid ${theme.disabledGrey2};
  box-shadow: 0px 6px 6px 0px ${theme.darkGreyBg};
  object-fit: contain;
  flex-shrink: 0;
`;

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 32px;
  font-weight: ${fontWeight.black};
  color: ${theme.blackText};
  line-height: 1;

  @media ${deviceType.mobile} {
    font-size: ${fontSize.font24};
  }
`;

const Subtitle = styled.span`
  font-size: ${fontSize.font16};
  font-weight: ${fontWeight.regular};
  color: ${theme.greyText};
  line-height: 1.4;

  @media ${deviceType.mobile} {
    font-size: ${fontSize.font14};
  }
`;

const CompareLink = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  background: none;
  font-size: ${fontSize.font14};
  font-weight: ${fontWeight.bold};
  color: ${theme.blueText};
  cursor: pointer;
  padding: 0;
  white-space: nowrap;
  align-self: center;

  @media ${deviceType.mobile} {
    align-self: flex-start;
  }
`;

const ArrowSvg = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M5.33 3.33L9.66 8 5.33 12.67"
      stroke={theme.blueText}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ──── Component ────

interface HeaderProps {
  data?: IPlansHeaderData;
  compareCta?: string;
  onCompareClick?: () => void;
}

const Header = ({ data, compareCta, onCompareClick }: HeaderProps) => {
  if (!data) return null;

  return (
    <HeaderWrapper>
      <HeaderLeft>
        {data.icon && <InsurerLogo src={data.icon} alt="Insurer" />}
        <TitleBlock>
          {data.title && <Title>{data.title}</Title>}
          {data.subtitle && (
            <Subtitle>
              <FormattedText value={data.subtitle} />
            </Subtitle>
          )}
        </TitleBlock>
      </HeaderLeft>
      {compareCta && (
        <CompareLink onClick={onCompareClick}>
          {compareCta}
          <ArrowSvg />
        </CompareLink>
      )}
    </HeaderWrapper>
  );
};

export default Header;
